//  function updateFormInput(e) {
//    // console.log("New variant quick add selection chosen");

//    // console.log(e)
//    // console.log(e.target)

//     // Get the value of .quick-sizing-swatch
//    var formValue = document.querySelector('product-form').getAttribute('data-value');
//    var swatchValue = e.target.getAttribute('data-value');
//    var productValue = e.target.getAttribute('product-value');
//    var variantValue = e.target.getAttribute('variant-value');

//    // console.log('swatchValue = ' + swatchValue)
//    // console.log('productValue = ' + productValue)
//    // console.log('variantValue = ' + variantValue)

//     // Set the value of the form input
//    //console.log(document.getElementById(productValue+'-variant-swatch'))
//     document.getElementById(productValue+'-variant-swatch').value = variantValue;
//     document.getElementById(productValue+'-variant-swatch').setAttribute('data-selected-variant', variantValue)
//     //document.getElementsByClassName(productValue+'-product-card-form')[0].submit();

//      //console.log(document.getElementsByClassName(productValue+'-atc-button')[0])
//     let atc = document.getElementsByClassName(productValue + "-atc-btn")[0]
//     //console.log(atc)
//      atc.click();
//     //document.getElementsByClassName(productValue+'-atc-button')[0].click();
//   }

  function updateFormInput(e) {

  var swatchValue = e.currentTarget.getAttribute('data-value');
  var productValue = e.currentTarget.getAttribute('product-value');
  var variantValue = e.currentTarget.getAttribute('variant-value');

  const input = document.getElementById(productValue + '-variant-swatch');

  if (input) {
    input.value = variantValue;
    input.setAttribute('data-selected-variant', variantValue);
  }

  let atc = document.getElementsByClassName(productValue + "-atc-btn")[0];

  if (atc) {
    atc.click();
  }
}